import React, { useEffect, useState } from "react";
import { Spin, Table } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link } from "react-router-dom";
import backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import InputLabel from "@mui/material/InputLabel";
import { MenuItem, Select, TextField } from "@mui/material";
import {
  addCurrency,
  deleteCurrency,
  editCurrency,
  getCurrency,
  getCurrencyById,
} from "../../../service/api";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import ReactSelect from "react-select";
import moment from "moment";
import { sanitizeInput, validateFile, decryptString } from "../../../config/validation";
import { MdDelete } from "react-icons/md";
import { triggerDownload } from "../../../config/downloadUtils";

const formatDate = (val) => (val ? moment(val).format("DD/MM/YYYY") : "-");

const ALL_COLUMNS = [
  {
    key: "name",
    title: "Currency Name",
    defaultVisible: true,
    render: (r) => r?.name || "-",
  },
  {
    key: "symbol",
    title: "Symbol",
    defaultVisible: true,
    render: (r) => r?.symbol || "-",
  },
  {
    key: "image",
    title: "Currency Image",
    defaultVisible: true,
    render: (r) =>
      r?.image ? (
        <img
          src={r.image}
          alt=""
          draggable="false"
          onContextMenu={(e) => e.preventDefault()}
          style={{ width: "36px", height: "36px", borderRadius: "12px" }}
        />
      ) : (
        "-"
      ),
  },
  {
    key: "isBuySell",
    title: "Buy/Sell",
    defaultVisible: false,
    render: (r) => (r?.isBuySell ? "Yes" : "No"),
  },
  {
    key: "isP2PSupport",
    title: "P2P Support",
    defaultVisible: false,
    render: (r) => (r?.isP2PSupport ? "Yes" : "No"),
  },
  {
    key: "createdAt",
    title: "Date",
    defaultVisible: false,
    render: (r) => formatDate(r?.createdAt),
  },
];

const buySellOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    height: "40px",
    width: "200px",
    minWidth: "120px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    fontSize: "14px",
    padding: "0px 4px",
    backgroundColor: "#fff",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
  }),
  indicatorSeparator: () => ({ display: "none" }),
};

const styleDelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 290,
  background: "white",
  // border: '1px solid #000',
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

const Currency = () => {
  const [roleInput, setroleInput] = useState({
    name: "",
    symbol: "",
    image: "",
    isBuySell: "",
    isP2PSupport: false,
  });
  const [preview, setPreview] = useState("");
  const [logo, setLogo] = useState(false);
  // console.log("roleInput: ", roleInput);
  const [roleInputError, setroleInputError] = useState({
    name: false,
    symbol: false,
    image: false,
    isBuySell: false,
    isP2PSupport: false,
  });
  const [userList, setCurrencyList] = useState([]);
  console.log("userList: ", userList);

  const [user, setUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const [id, setId] = useState(false);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [buySellFilter, setBuySellFilter] = useState(null);

  const {
    pageSize,
    setPageSize,
    pageSizeOptions,
    visibleColumnKeys,
    toggleColumn,
    resetColumns,
    dynamicColumns,
  } = useTableSettings({
    storageKey: "currency-list",
    allColumns: ALL_COLUMNS,
  });

  const roleChange = (e) => {
    if (e.target.type === "file") {
      const file = e.target.files[0];
      const error = validateFile(file);
      if (error) {
        toast.error(error);
        e.target.value = null;
        return;
      }

      setroleInput({ ...roleInput, [e.target.name]: file });
      setLogo(true);
      const reader = new FileReader();
      reader.onload = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      const { name, value } = e.target;
      setroleInput({ ...roleInput, [name]: sanitizeInput(value) });
    }
    setroleInputError({ ...roleInputError, [e.target.name]: false });
  };

  const getCurrencyList = () => {
    let body = {
      page: page,
      sizePerPage: pageSize,
      pagination: true,
    };
    if (searchTerm) {
      body.search = searchTerm;
    }
    if (buySellFilter && buySellFilter.value !== undefined) {
      body.isBuySell = buySellFilter.value;
    }

    setLoading(true);
    getCurrency(body)
      .then((res) => {
        console.log("res---->", res);
        if (res?.status) {
          setCurrencyList(res?.data);
        }
        setLoading(false);
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  const handleClear = () => {
    setroleInput({
      ...roleInput,
      name: "",
      isP2PSupport: false,
      isBuySell: "",
      symbol: "",
      image: "",
    });
    setroleInputError({
      name: false,
      isP2PSupport: false,
      isBuySell: false,
      symbol: false,
      image: false,
    });
  };
  // ADD USER FUNCTION
  const addUserFun = async () => {
    console.log(roleInput);
    if (!roleInput?.name && !roleInput?.image && !roleInput?.symbol) {
      setroleInputError({
        ...roleInputError,
        name: true,
        symbol: true,
        image: true,
      });
      return;
    } else if (!roleInput?.name) {
      setroleInputError({ ...roleInputError, name: true });
      return;
    } else if (!roleInput?.symbol) {
      setroleInputError({ ...roleInputError, symbol: true });
      return;
    }
    //  else if (
    //   roleInput?.isP2PSupport === undefined ||
    //   roleInput?.isP2PSupport === null ||
    //   typeof roleInput?.isP2PSupport !== "boolean"
    // ) {
    //   setroleInputError({ ...roleInputError, isP2PSupport: true });
    //   toast.error("Please Select P2P Enable");
    //   return;
    // }
    else if (
      roleInput?.isBuySell === undefined ||
      roleInput?.isBuySell === null ||
      typeof roleInput?.isBuySell !== "boolean"
    ) {
      setroleInputError({ ...roleInputError, isBuySell: true });
      toast.error("Please Select P2P Enable");
      return;
    } else if (!roleInput?.image) {
      setroleInputError({ ...roleInputError, image: true });
      return;
    }
    if (roleInput) {
      setLoading(true);
      if (!edit) {
        // Create plain object with text fields to encrypt
        const plainData = {
          isBuySell: roleInput?.isBuySell,
          isP2PSupport: roleInput?.isP2PSupport,
          name: sanitizeInput(roleInput?.name),
          symbol: sanitizeInput(roleInput?.symbol),
        };

        // Encrypt the plain object
        const encryptedData = await decryptString(plainData);

        // Create FormData with image and encrypted data
        const formData = new FormData();
        formData.append("image", roleInput?.image);
        formData.append("encrypt", encryptedData);

        addCurrency(formData)
          .then((res) => {
            console.log("response api", res);
            if (res?.status) {
              toast.success(res?.message, { toastId: 'currency-add-success' });
              setUser(false);
              getCurrencyList();
              handleClear();
            } else {
              toast.error(res?.message, { toastId: 'currency-add-error' });
            }
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message, { toastId: 'currency-add-error' });
          })
          .finally((res) => {
            setLoading(false);
          });
      } else {
        // Create plain object with text fields to encrypt
        const plainData = {
          isBuySell: roleInput?.isBuySell,
          isP2PSupport: roleInput?.isP2PSupport,
          symbol: sanitizeInput(roleInput?.symbol),
        };

        // Encrypt the plain object
        const encryptedData = await decryptString(plainData);

        // Create FormData with image and encrypted data
        const formData = new FormData();
        if (roleInput?.image?.type) {
          formData.append("image", roleInput?.image);
        }
        formData.append("encrypt", encryptedData);

        editCurrency(id?._id, formData)
          .then((res) => {
            console.log("response api", res);
            if (res?.status) {
              toast.success(res?.message, { toastId: 'currency-add-success' });
              setEdit(false);
              setUser(false);
              getCurrencyList();
              handleClear();
            } else {
              toast.error(res?.message, { toastId: 'currency-add-error' });
            }
          })
          .catch((err) => {
            console.log("%c Line:216 🍇 err", "color:#3f7cff", err);
            toast.error(err?.response?.data?.message, { toastId: 'currency-add-error' });
          })
          .finally((res) => {
            setLoading(false);
          });
      }
    }
  };
  // DELETE USER FUNCTION

  const handleDeleteFunction = () => {
    setLoading(true);
    deleteCurrency(id?._id)
      .then((res) => {
        console.log("res: ", res);
        if (res?.status) {
          toast.success(res?.message);
          handleCloseDelete();
          getCurrencyList();
          setId(null);
        } else {
          toast.error(res?.message);
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.response?.data?.message);
      })
      .finally((res) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getCurrencyList();
  }, [page, pageSize, searchTerm, buySellFilter]);

  // Reset to page 1 whenever filters or page size change.
  useEffect(() => {
    setPage(1);
  }, [pageSize, searchTerm, buySellFilter]);

  const handleDownload = (format) => {
    const body = { pagination: false };
    if (searchTerm) body.search = searchTerm;
    if (buySellFilter?.value !== undefined) body.isBuySell = buySellFilter?.value;
    setDownloadLoading(true);
    getCurrency(body)
      .then((res) => {
        const result = res?.data?.result ?? [];
        if (!result?.length) { toast.warning("Nothing to download", { toastId: 'nothing-to-download' }); return; }
        const cols = ALL_COLUMNS?.filter((c) => visibleColumnKeys?.includes(c?.key));
        triggerDownload(format, result, cols, "currencies");
      })
      .finally(() => setDownloadLoading(false));
  };

  const getCurrencyDataById = (id) => {
    getCurrencyById(id)
      ?.then((res) => {
        console.log("%c Line:264 🍻 res", "color:#6ec1c2", res);
        if (res?.status) {
          let data = res?.data;
          setroleInput({
            ...roleInput,
            isBuySell: !!data?.isBuySell,
            isP2PSupport: false,
            symbol: data?.symbol,
            image: data?.image,
            name: data?.name,
          });
          if (data?.image) {
            setLogo(true);
          }
        }
      })
      .catch((e) => {
        console.log("%c Line:267 🥟 e", "color:#fca650", e);
      });
  };

  const actionColumn = {
    key: "__action",
    title: "Action",
    className: "text-end",
    render: (_, row) => (
      <div className="text-end">
        {row?.status === 0 && (
          <a
            className="me-1 btn btn-sm bg-success-light "
            onClick={() => {
              setId(row);
              setLogo(false);
              setPreview("");
              handleClear();
              setUser(true);
              setEdit(true);
              getCurrencyDataById(row?._id);
            }}
          >
            <i className="fe fe-pencil"></i> Edit
          </a>
        )}
        {/* {permission &&
            permission?.length > 0 &&
            permission?.find((module) => module.module === "User")?.delete && ( */}
        <a
          onClick={() => {
            handleOpenDelete(), setId(row);
          }}
          className="me-1 btn btn-sm bg-danger-light"
        >
          <i className="fe fe-trash"></i> Delete
        </a>
        {/* )} */}
      </div>
    ),
  };

  const columns2 = [...dynamicColumns, actionColumn];

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-aut0">
                <h3 className="page-title">Currency</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Currency</li>
                </ul>
              </div>
              {!user && (
                <div className="col-sm-5 col">
                  <a
                    onClick={() => {
                      handleClear(),
                        setEdit(false),
                        setUser(true),
                        setLogo(false);
                    }}
                    data-bs-toggle="modal"
                    className="btn btn-primary float-end mt-2"
                  >
                    Add Currency
                  </a>
                </div>
              )}
            </div>
          </div>

          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              {user ? (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0px",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      <FaArrowLeft
                        style={{
                          marginTop: "3px",
                          cursor: "pointer",
                          width: "30px",
                          height: "20px",
                        }}
                        onClick={() => {
                          setEdit(false), setUser(false);
                        }}
                      />
                      <h4>{edit ? "Edit Currency" : "Add Currency"}</h4>
                    </div>{" "}
                    <div
                      style={{
                        // borderTop: "1px solid grey",
                        height: "56px",
                        display: "flex",
                        justifyContent: "end",
                        // marginTop: "30px",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        onClick={addUserFun}
                        disabled={loading}
                        style={{ marginBottom: "10px", marginTop: "9px" }}
                      >
                        {loading ? (
                          <Spinner size="sm" />
                        ) : edit ? (
                          "Update"
                        ) : (
                          "Add"
                        )}
                      </button>
                    </div>
                  </div>
                  <div style={{ margin: "10px" }} className="page-grid">
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Currency Name &nbsp;
                        {roleInputError?.name && (
                          <small style={{ color: "red" }}>
                            {"Currency Name is required"}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="text"
                        placeholder="Bitcoin"
                        value={roleInput?.name}
                        onChange={roleChange}
                        disabled={edit}
                        name="name"
                        id="name"
                      />
                    </div>
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Currency Symbol &nbsp;
                        {roleInputError?.symbol && (
                          <small style={{ color: "red" }}>
                            {"Currency Symbol is required"}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="text"
                        placeholder="Currency Symbol"
                        value={roleInput?.symbol}
                        onChange={roleChange}
                        name="symbol"
                        id="symbol"
                      />
                    </div>
                    {/* <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        P2P Enable &nbsp;
                        {roleInputError?.isP2PSupport && (
                          <small style={{ color: "red" }}>
                            {"P2P is required"}
                          </small>
                        )}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="form-control"
                        value={roleInput?.isP2PSupport}
                        onChange={roleChange}
                        name="isP2PSupport"
                        style={{
                          border: "none",
                          padding: 0,
                          height: "56px",
                        }}
                      >
                        <MenuItem style={{ height: "50px" }} value={true}>
                          Yes
                        </MenuItem>
                        <MenuItem style={{ height: "50px" }} value={false}>
                          No
                        </MenuItem>
                      </Select>
                    </div> */}
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Buy/Sell &nbsp;
                        {roleInputError?.isBuySell && (
                          <small style={{ color: "red" }}>
                            {"Buy/Sell is required"}
                          </small>
                        )}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="form-control"
                        value={roleInput?.isBuySell}
                        onChange={roleChange}
                        name="isBuySell"
                        style={{
                          border: "none",
                          padding: 0,
                          height: "56px",
                        }}
                      >
                        <MenuItem style={{ height: "50px" }} value={true}>
                          Yes
                        </MenuItem>
                        <MenuItem style={{ height: "50px" }} value={false}>
                          No
                        </MenuItem>
                      </Select>
                    </div>
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Currency Image &nbsp;
                      </InputLabel>

                      {!logo ? (
                        <TextField
                          variant="outlined"
                          style={{
                            // width: "370px",
                            marginLeft: "5px",
                            height: "100%",
                          }}
                          className="form-control"
                          type="file"
                          inputProps={{ accept: "image/jpeg,image/png,image/gif,image/bmp,image/webp" }}
                          placeholder="File upload"
                          onChange={roleChange}
                          name="image"
                          id="image"
                        />
                      ) : (
                        <div className="img-incoming-div">
                          <img
                            src={preview ? preview : roleInput?.image}
                            alt=""
                            draggable="false"
                            onContextMenu={(e) => e.preventDefault()}
                            className="img-incoming"
                          />
                          <MdDelete
                            onClick={() => {
                              setLogo(false);
                              setroleInput({ ...roleInput, image: "" });
                              setPreview("");
                            }}
                            className={`img-incoming-icon display-flex`}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="list-layout">
                  <div className="list-layout__main">
                    <div className="card">
                      <div className="card-body">
                        <TableToolbar
                          pageSize={pageSize}
                          setPageSize={setPageSize}
                          pageSizeOptions={pageSizeOptions}
                          total={userList?.total}
                          page={page}
                          visibleColumnKeys={visibleColumnKeys}
                          allColumns={ALL_COLUMNS}
                          toggleColumn={toggleColumn}
                          resetColumns={resetColumns}
                          onDownload={handleDownload}
                          downloadLoading={downloadLoading}
                        />
                        <div className="table-responsive">
                          {loading ? (
                            <div className="his-spin">
                              <Spin
                                size="large"
                                style={{ position: "relative", top: "35%" }}
                              />
                            </div>
                          ) : (
                            <Table
                              pagination={false}
                              style={{ overflowX: "auto" }}
                              columns={columns2}
                              dataSource={userList ? userList?.result : []}
                              rowKey={(record) => record._id || record.id}
                            />
                          )}
                          {userList && userList?.total > pageSize && (
                            <CustomPagination
                              key={`pg-${pageSize}`}
                              totalTabs={userList?.total}
                              tabsPerPage={pageSize}
                              handleChange={setPage}
                              className={`${
                                loading ? "display-hide" : "display-flex"
                              }`}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="list-layout__filters">
                    <FilterPanel
                      count={userList?.total}
                      onClear={() => {
                        setSearchTerm("");
                        setBuySellFilter(null);
                      }}
                    >
                      <FilterPanel.Field label="Search">
                        <input
                          type="text"
                          placeholder="Name or symbol"
                          value={searchTerm}
                          onChange={(e) =>
                            setSearchTerm(sanitizeInput(e.target.value))
                          }
                        />
                      </FilterPanel.Field>
                      <FilterPanel.Field label="Buy/Sell">
                        <ReactSelect
                          options={buySellOptions}
                          value={buySellFilter || null}
                          onChange={(option) => setBuySellFilter(option)}
                          styles={customStyles}
                          placeholder="Any"
                          isClearable
                        />
                      </FilterPanel.Field>
                    </FilterPanel>
                  </div>
                </div>
              )}
            </div>
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openDelete}
            onClose={handleCloseDelete}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openDelete}>
              <Box style={styleDelete}>
                <div style={{ margin: "10px", textAlign: "center" }}>
                  Please confirm before deleting
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    className="btn btn-danger"
                    disabled={loading}
                    onClick={handleDeleteFunction}
                    style={{ marginBottom: "10px", marginTop: "15px" }}
                  >
                    {loading ? <Spinner size="sm" /> : "Delete"}
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleCloseDelete}
                    style={{
                      marginLeft: "7px",
                      marginBottom: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Currency;
